import { EArticleStatus } from "../../../../types/blog.type";

export const renderTextStatus = (status: EArticleStatus | "DELETE") => {
	switch (status) {
		case EArticleStatus.PUBLISH:
			return "Published";

		case EArticleStatus.OPEN:
			return "Draft";

		case EArticleStatus.SCHEDULED:
			return "Scheduled";

		case EArticleStatus.NEED_APPROVAL:
			return "Waiting Approval";

		case "DELETE":
			return "Delete";

		default:
			break;
	}
};
